import { useLocation } from 'react-router';

function useCanonical() {
  const { pathname } = useLocation();
  const base = import.meta.env.VITE_BASE_URL || window.location.origin;
  const canonicalPath = pathname.endsWith('/') && pathname !== '/'
    ? pathname.slice(0, -1)
    : pathname;
  const canonical = `${base}${canonicalPath}`;

  return { canonical };
}

export default useCanonical;
